// SCRUM-385: place Rekognition face boxes (fractions of the photo) on the displayed
// image. `letterboxed` means the image is the photo fitted inside a square on black
// (the owned preview), so the picture occupies a centred band; the original is not.
export function faceRects(faces, photoWidth, photoHeight, letterboxed) {
  if (!Array.isArray(faces) || faces.length === 0) return [];
  let scaleX = 1, scaleY = 1, offX = 0, offY = 0;
  if (letterboxed) {
    if (!photoWidth || !photoHeight) return [];
    const side = Math.max(photoWidth, photoHeight);
    scaleX = photoWidth / side;
    scaleY = photoHeight / side;
    offX = (1 - scaleX) / 2;
    offY = (1 - scaleY) / 2;
  }
  return faces.map((f) => ({
    faceId: f.faceId,
    attendeeId: f.attendeeId,
    fullName: f.fullName,
    facePx: f.facePx,
    // auto | confirmed | suppressed | null, and whether the parent sees it —
    // a named face is not automatically a live match (SCRUM-385).
    status: f.status ?? null,
    visible: !!f.visible,
    // SCRUM-357: stored review reasons (adultFace/smallFace/eyesClosed) for
    // this face — always an array, even when the API omits it.
    reviewReasons: f.reviewReasons ?? [],
    left: (offX + f.box.left * scaleX) * 100,
    top: (offY + f.box.top * scaleY) * 100,
    width: f.box.width * scaleX * 100,
    height: f.box.height * scaleY * 100,
  }));
}
